export default __webpack_public_path__ + "static/media/img-1.2d6f5328.png";